import React from 'react';
import Hero from './components/HeroV3';
import ImpactNumbers from './components/ImpactNumbers';
import AboutV3 from './components/AboutV3';
import FeaturedWork from './components/FeaturedWork';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';
import ScrollProgress from './components/ScrollProgress';
import SEO from './components/SEO';
import { resumeData } from './data/resumeData';
import { Linkedin, Github } from 'lucide-react';

const AppV3 = () => {
    return (
        <div className="min-h-screen bg-background text-text font-sans relative overflow-hidden">
            <SEO
                title="Victor Cuerdo | Platform Support Engineer"
                description="Platform Support Engineer with 5+ years in SaaS operations, AWS/Azure cloud infrastructure, and workflow automation. Engineered tooling that cut configuration time by 95%."
                name="Victor Cuerdo"
            />
            <ScrollProgress />
            <ScrollToTop />

            {/* Fixed Navigation */}
            <nav className="fixed top-0 w-full z-50 bg-background/80 backdrop-blur-2xl border-b border-border">
                <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
                    <a href="#" className="text-text font-display font-bold text-lg tracking-tight hover:text-primary transition-colors duration-300">
                        VC<span className="text-primary">.</span>
                    </a>
                    <div className="flex items-center gap-2">
                        {/* Nav links - hidden on mobile */}
                        <div className="hidden md:flex items-center gap-8 mr-8">
                            <a href="#about" className="text-xs text-text-secondary hover:text-primary transition-colors duration-300 uppercase tracking-wider font-mono">About</a>
                            <a href="#work" className="text-xs text-text-secondary hover:text-primary transition-colors duration-300 uppercase tracking-wider font-mono">Work</a>
                            <a href="#experience" className="text-xs text-text-secondary hover:text-primary transition-colors duration-300 uppercase tracking-wider font-mono">Experience</a>
                            <a href="#skills" className="text-xs text-text-secondary hover:text-primary transition-colors duration-300 uppercase tracking-wider font-mono">Skills</a>
                            <a href="#contact" className="text-xs text-text-secondary hover:text-primary transition-colors duration-300 uppercase tracking-wider font-mono">Contact</a>
                        </div>

                        {/* Social icons */}
                        <div className="flex items-center gap-1">
                            <a
                                href={resumeData.main.website}
                                target="_blank"
                                rel="noreferrer"
                                className="p-2 text-text-tertiary hover:text-primary transition-colors duration-300"
                                title="LinkedIn"
                            >
                                <Linkedin size={16} />
                            </a>
                            <a
                                href={resumeData.main.github}
                                target="_blank"
                                rel="noreferrer"
                                className="p-2 text-text-tertiary hover:text-primary transition-colors duration-300"
                                title="GitHub"
                            >
                                <Github size={16} />
                            </a>
                        </div>

                        {/* CTA */}
                        <a
                            href={`mailto:${resumeData.main.email}`}
                            className="ml-3 px-5 py-2 bg-primary text-white text-xs font-bold uppercase tracking-wider rounded-lg hover:bg-primary-light transition-all duration-300 shadow-glow-sm hover:shadow-glow"
                        >
                            Contact
                        </a>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <main className="relative z-10">
                <Hero data={resumeData.main} />
                <ImpactNumbers metrics={resumeData.resume.impactMetrics} />
                <AboutV3 data={resumeData.main} />
                <FeaturedWork />
                <Experience data={resumeData.resume.work} />
                <Skills skills={resumeData.resume.skills} />
                <Contact data={resumeData.main} />
            </main>

            {/* Footer */}
            <footer className="border-t border-border py-8">
                <div className="max-w-6xl mx-auto px-6 text-center">
                    <p className="text-text-tertiary text-sm">
                        &copy; {new Date().getFullYear()} Victor Cuerdo. Built with React & Tailwind CSS.
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default AppV3;
